import { CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useServices } from "@/context/ServicesContext";
import { formatDate } from "@/lib/services";

export const TrialBanner = () => {
  const { user } = useAuth();
  const { openBilling } = useServices();
  const b = user?.billing;
  if (!b || b.exempt || user.tenant_role !== "owner") return null;
  const show = (b.status === "trial" && !b.subscribed) || b.status === "past_due" || b.status === "canceled";
  if (!show) return null;
  const text = b.status === "trial" ? `Período grátis até ${formatDate(b.paid_until)}.` : `Pagamento pendente. Acesso liberado até ${formatDate(b.paid_until)}.`;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm" data-testid="trial-banner">
      <span className="text-amber-200">{text} Assine para não perder o acesso.</span>
      <Button size="sm" onClick={openBilling} className="rounded-full" data-testid="trial-banner-subscribe"><CreditCard className="mr-1 h-3.5 w-3.5" /> Assinar</Button>
    </div>
  );
};
